import * as d3 from 'd3'
export default {
  methods: {


    table_Header() {
      let tbl = this.table
      let head = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      head
      .append('rect')
      .attr('x', 0).attr('y', 2)
      .attr('width', tbl.width).attr('height', this.header.height-4)
      .attr('fill', '#F4F5F5').attr('fill-opacity', .75)

      this.gmx_Line(head, 0, tbl.width, 0, 0, '#bcbcbc', .5, 1)
      this.gmx_Line(head, 0, tbl.width, this.header.height, this.header.height, '#bcbcbc', .5, 1)

      this.columns.forEach((d,i) => {
        this.gmx_Text(head, '', d.mx, this.header.height/2 + 3, 11, '#000', 'middle', '', d.name)
      })
    },


    table_DataGrid() {
      let tbl = this.table
      let y_ = tbl.lineHeight/2+1
      
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.height})`)

      this.rawData.forEach((d,i)=> {

        this.columns.forEach((col,c)=> {

          if(col.code.substr(0,4) == 'PROG') {
            this.gmx_ProgressBar(table, col.sx, y_, d[col.code], col.vSize, col.vColor, {width:col.width, height:11, color: col.bColor ? col.bColor : '#B4E3FA', shift:70, opacity: .7, rx: 6})
          } else {
            // Merge
            if(c == 0 && i > 0 && (d[col.code] == this.rawData[i-1][col.code])) return

            table
            .append('text')
            .attr('x', col.tx).attr('y', y_+3)
            .attr('font-size', col.vSize).attr('fill', col.vColor).attr('text-anchor', col.align)
            .text(this.gmx_numFormat(d[col.code], col.unit))
            .call(this.event_Link, d, col)
          }
      
        })

        let TotalLine = tbl.total == 'N' ? 1 : 2

        let x_ = (i < this.rawData.length-TotalLine && (d.DISC == this.rawData[i+1].DISC)) ? this.columns[0].ex : 0
        table
        .append('line')
        .attr('x1', x_).attr('y1', y_ + (tbl.lineHeight/2))
        .attr('x2', tbl.width).attr('y2', y_ + (tbl.lineHeight/2))
        .attr('stroke', x_==0 ? '#bcbcbc' : '#E0E0DF').attr('stroke-width', .5).attr('opacity', .5)

        y_ = y_ + tbl.lineHeight
      })

    },
    
  }
}